import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServiceTypeEnum } from './features/activities/shared/models/service-type.enum';

@Injectable()
export class FeatureService {
  public imageRegex = /\.(jpeg|jpg|gif|png|bmp|svg)$/;
  public pngRegex = /\.png$/;
  public zenDeskUrl: ReplaySubject<string> = new ReplaySubject(1);
  private userCompany: any;
  public cachedZendeskUrl = '';
  public GaMemberShipType = '';
  public links = [
    {
      label: 'Home',
      route: ['/home'],
      active: false,
    },
    {
      label: 'Report Past Activity',
      route: ['/activities/create/report-view'],
      angulartics: {
        action: 'Report Activity Top Nav',
        label: 'Report Activity Top Nav',
      },
      active: false,
    },

    {
      label: 'Plan Future Activity',
      angulartics: {
        action: 'New Activity Top Nav',
        label: 'New Activity Top Nav',
      },
      route: ['/activities/create', { type: ServiceTypeEnum.Future }, 'new'],
      active: false,
    },
    {
      label: 'Activities',
      route: ['/activities/discover'],
      active: false,
    },
    {
      label: 'Metrics',
      route: ['/activities/explore'],
      active: false,
    },
  ];

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  getZendeskUrl(emitEvent = true): Observable<any> {
    return this.http.get(`mobileapi://zendeskurl`).pipe(
      tap((res) => {
        if (emitEvent) {
          this.zenDeskUrl.next(res);
        }
      })
    );
  }

  getMenuLinks(): Observable<any> {
    return of(this.links);
  }

  activateMenuLink(index) {
    for (let i = 0; i < this.links.length; i++) {
      this.links[i].active = false;
    }
    this.links[index].active = true;
  }

  getAlerts(userId: any): Observable<any> {
    return this.http.get(`mobileapi://users/${userId}/alerts`);
  }

  viewAlert(userId: any, alertId: any): Observable<any> {
    return this.http.post(
      `mobileapi://users/${userId}/alerts/${alertId}/view`,
      {}
    );
  }

  getAlert(userId: any, alertId: any): Observable<any> {
    return this.http.get(`mobileapi://users/${userId}/alerts/${alertId}`);
  }

  public addFeatureRoutes() {
    /* const rootRoute = this.router.config.find(route => {
      return route.path === '';
    });
    if (rootRoute) {
      rootRoute.children.push({
        path: 'features',
        children: [{
          path: 'lazy',
          loadChildren: 'features/activities/activities.module#ActivitiesModule'
        }]
      });
    }*/
  }

  /**
   * Get company
   */
  public getCompanyById(
    companyId: number,
    cache: boolean = false
  ): Observable<any> {
    const params = {
      filter: `(CompanyId eq '${companyId}')`,
    };
    if (cache) {
      if (!this.userCompany) {
        return this.http.get(`mobileapi://companies/search`, { params }).pipe(
          tap((res) => {
            this.userCompany = res;
          })
        );
      } else {
        return of(this.userCompany);
      }
    } else {
      return this.http.get(`mobileapi://companies/search`, { params });
    }
  }

  public getCompanies(companyIds: string[]): Observable<any> {
    const companyStrings = [];
    for (const companyId of companyIds) {
      companyStrings.push(`(CompanyId eq '${companyId}')`);
    }
    const params = {
      filter: `true and (${companyStrings.join(' or ')})`,
    };
    return this.http.get(`mobileapi://companies/search`, { params }).pipe(
      map((res: any) => {
        return res.results
          .map((d) => d.document)
          .sort((a, b) => {
            return (
              companyIds.indexOf(a.companyId) - companyIds.indexOf(b.companyId)
            );
          });
      })
    );
  }

  public getApplications(userId): Observable<any> {
    return this.http.get(`apiurl://users/${userId}/applications`);
  }

  /**
   * Retreives mylci redirect and token
   */
  public getSSO(): Observable<any> {
    return this.http.get(`apiurl://users/sso`);
  }

  public getUserSettings(userId: string): Observable<any> {
    return this.http.get(`apiurl://users/${userId}/settings`);
  }

  public createUserSetting(userId: string, userSetting: any): Observable<any> {
    return this.http.post(`apiurl://users/${userId}/settings`, userSetting);
  }

  public updateUserSetting(userId: string, userSetting: any): Observable<any> {
    return this.http.put(`apiurl://users/${userId}/settings`, userSetting);
  }
  public companyDetails(cId): Observable<any> {
    return this.http.get(`mobileapi://companies/${cId}`);
  }
  public getApplicationSettings(): Observable<any> {
    return this.http.get(`configurl://applicationSettings`);
  }

  getFormattedDate(date: Date) {
    return date.getFullYear() + '-'
      + (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) + '-'
      + date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) + 'T'
      + date.getHours().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) + ':'
      + date.getMinutes().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) + ':'
      + date.getSeconds().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) + '.'
      + date.getMilliseconds().toLocaleString('en-US', { minimumIntegerDigits: 3, useGrouping: false }) + 'Z';
  }
}
